import { render, staticRenderFns } from "./pricingConfiguration.vue?vue&type=template&id=5567ab29&"
import script from "./pricingConfiguration.vue?vue&type=script&lang=js&"
export * from "./pricingConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports